<template>
  <v-card
    class="px-3 py-3 mx-2 my-2 round-corners"
    :color="backgroundColor"
    dark
    min-width="400"
    max-width="450"
    @click="goTo"
  >
    <v-card-title style="height: 100%">
      <v-row>
        <v-col cols="12">
          <v-container bg fill-height>
            <v-layout>
              <v-icon x-large>
                {{ icon }}
              </v-icon>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-container>
            <v-layout class="px-1">
              <h3>
                {{ text }}
              </h3>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>

    </v-card-title>
  </v-card>
</template>

<script>
import {EventBus} from "../../event-bus";

export default {
  props: {
    text: {
      default: 'Home'
    },
    to: {
      default: ''
    },
    is_link: {
      default: false,
    },
    backgroundColor: {
      default: 'gray'
    },
    hasRoundCorners: {
      default: false,
    },
    hasBoxShadow: {
      default: true
    },
    icon: {
      default: 'mdi-twitter'
    }

  },
  name: "Cards",
  // data() {
  //     return {
  //         bgcolor: this.props.color,
  //     }
  // },
  methods: {
    goTo() {
      if (this.is_link) {
        this.$router.push(this.to)
      } else {
        EventBus.$emit('externalOpenLink', {link: this.to, openDrawer: true});
      }
    }
  }
}
</script>

<style scoped>
.round-corners {
  border-radius: 15px 15px 15px 15px !important;

}
</style>
